import { HttpStatusCode } from "@/api";

const REDIRECT_STATUS_CODES = [
  HttpStatusCode.MULTIPLE_CHOICES,
  HttpStatusCode.MOVED_PERMANENTLY,
  HttpStatusCode.FOUND,
  HttpStatusCode.SEE_OTHER,
  HttpStatusCode.NOT_MODIFIED,
  HttpStatusCode.USE_PROXY,
  HttpStatusCode.SWITCH_PROXY,
  HttpStatusCode.TEMPORARY_REDIRECT,
  HttpStatusCode.PERMANENT_REDIRECT
];

export function isRedirect(code: number): boolean {
  return REDIRECT_STATUS_CODES.includes(code);
}
